@if(initialized) {

  <div class="p-2">
    <div class="max-w-75rem">
      <div class="surface-card border-round-2xl w-full">

        <div class="text-center mb-5 mt-4">
          <img src="../../../../assets/images/logo_klaus_light_blue.svg" alt="logo" style="width:30%">
        </div>

        <div class="text-center mb-6">
          <span class="text-600 font-medium line-height-3 text-color-secondary">Version 1.0.0</span>
        </div>

        <div class="my-2 text-center">
          <label class="block text-900 mb-2">© 2025 KLAUS, Inc. All rights reserved
          </label>
        </div>

      </div>
    </div>



  </div>

}
